import request from "@/utils/request";

//网站首页内容
export function gethomepage(params) {
  return request({
    url: "/api/ros-developer-service/front/content/web/homepage",
    method: "get",
    params,
  });
}
//网站关于我们
export function getAboutUs(params) {
  return request({
    url: "/api/ros-developer-service/front/content/about/us/index",
    method: "get",
    params,
  });
}
//网站解决方案
export function solution(params) {
  return request({
    url: "/api/ros-developer-service/front/content/solution/index",
    method: "get",
    params,
  });
}
//网站资源中心
export function resourceCenter(params) {
  return request({
    url: "/api/ros-developer-service/front/content/resource/center/index",
    method: "get",
    params,
  });
}
// 网站资源中心侧边二级菜单
export function resourceSubMenu(params) {
  return request({
    url: "/api/ros-developer-service/front/content/resource/center/tree",
    method: "get",
    params,
  });
}

// 网站资源中心文档详情

export function resourceDetail(data) {
  return request({
    url: "/api/ros-developer-service/front/content/resource/center/detail",
    method: "post",
    data,
  });
}

//网站获取文档详情
export function documentByid(params) {
  return request({
    url: "/api/ros-developer-service/front/content/document/detail",
    method: "get",
    params,
  });
}
//网站获取新闻动态详情
export function getnewsdocumentByid(params) {
  return request({
    url: "/api/ros-developer-service/front/content/news/detail",
    method: "get",
    params,
  });
}
//网站获取平台详情
export function getplatdocumentByid(params) {
  return request({
    url: "/api/ros-developer-service/front/content/platform/function/detail",
    method: "get",
    params,
  });
}
//网站获取平台详情
export function getsolutiondocumentByid(params) {
  return request({
    url: "/api/ros-developer-service/front/content/solution/detail",
    method: "get",
    params,
  });
}
// 获取搜索列表
export function getSearchList(data) {
  return request({
    url: "/api/ros-developer-service/front/content/document/search",
    method: "post",
    data,
  });
}
// 获取app下载链接
export function getAppDownloadUrlApi(params) {
  return request({
    url: "/api/ros-developer-service/front/content/app/download",
    method: "get",
    params,
  });
}

// 资源下载项目列表
export function getResProjectListApi(params) {
  return request({
    url: "/api/ros-developer-service/front/content/resource/download/project/index",
    method: "get",
    params,
  });
}

// 资源下载资源列表
export function getResListApi(params) {
  return request({
    url: "/api/ros-developer-service/front/content/resource/download/project/list",
    method: "get",
    params,
  });
}

// 资源下载项目目录树
export function getResCatalogListApi(params) {
  return request({
    url: "/api/ros-developer-service/front/content/resource/download/project/tree",
    method: "get",
    params,
  });
}

// 资源下载分页查询更新日志
export function getResLogApi(params) {
  return request({
    url: "/api/ros-developer-service/front/content/resource/download/project/updateLogPage",
    method: "get",
    params,
  });
}

